var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdStyles } from "../../../../../../less/IdStyles";
import { ReplacementLoca } from "../../../../../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../../../../../utils/utilNumber";
import { actionBeginBuyWithGoldProcess } from "../../../../../buy-with-gold/actionBuyWithGold";
import { Icon } from "../../../../../generic/icon/Icon";
import { IdIcon } from "../../../../../generic/icon/IdIcon";
import { QuestSkipButton } from "../QuestSkipButton";
import { QuestTask } from "../QuestTask";
var _QuestTaskHaveHappiness = function (props) {
    var className = props.className, tasks = props.tasks, questInfoTasks = props.questInfoTasks, quest = props.quest, onTrySkip = props.onTrySkip;
    var task = tasks;
    var list = task.map(function (value) {
        var requiredInfoTask = questInfoTasks.find(function (val) { return val.index === value.index; });
        var currentHappinessAmount = requiredInfoTask.amount || 0;
        var taskCompleted = currentHappinessAmount >= value.amount;
        var locaReplacements = new Map([
            [ReplacementLoca.amount, utilNumber.format(value.amount)],
        ]);
        var icon = React.createElement(Icon, { icon: IdIcon.HappinessPositiveIcn, styleId: IdStyles.IconExtraLarge });
        var taskProps = {
            currentAmount: currentHappinessAmount,
            icon: icon,
            locaKey: value.locaKey,
            locaReplacements: locaReplacements,
            requiredAmount: value.amount,
            taskCompleted: taskCompleted,
        };
        var skipButtonProps = {
            currentAmount: currentHappinessAmount,
            onTrySkip: onTrySkip,
            questId: quest.id,
            requiredAmount: value.amount,
            skipCost: value.skipCost,
            taskCompleted: taskCompleted,
            taskIndex: value.index,
        };
        return (React.createElement(QuestTask, __assign({ key: value.locaKey + "_" + icon }, taskProps),
            React.createElement(QuestSkipButton, __assign({}, skipButtonProps))));
    });
    return (React.createElement("div", { key: "haveHappiness", className: className }, list));
};
var mapState = function (state) {
    return {
        baseInfo: state.baseInfo,
    };
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onTrySkip: actionBeginBuyWithGoldProcess,
    }, dispatch);
};
export var QuestTaskHaveHappiness = connect(mapState, mapDispatch)(_QuestTaskHaveHappiness);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/tasks/questTaskHaveHappiness/QuestTaskHaveHappiness.tsx
// module id = 2673
// module chunks = 3